export default __webpack_public_path__ + "static/media/signup-img.1edc098e.svg";